import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import type { LabelsBreakdownInsightProps, LabelsCriteriaInsightProps } from "./interfaces"

export const reportsSlice = createSlice({
  name: "reports",
  initialState: {
    labelsBreakdown: undefined as LabelsBreakdownInsightProps | undefined,
    labelsCriteria: undefined as LabelsCriteriaInsightProps | undefined,
  },
  reducers: {
    setLabelsBreakdown: (state, action: PayloadAction<LabelsBreakdownInsightProps | undefined>) => {
      state.labelsBreakdown = action.payload
    },
    setLabelsCriteria: (state, action: PayloadAction<LabelsCriteriaInsightProps | undefined>) => {
      state.labelsCriteria = action.payload
    },
  },
})

export const { setLabelsBreakdown, setLabelsCriteria } = reportsSlice.actions
